module.exports = __webpack_public_path__ + "img/Google Icon.6b9534b5.svg";